module.exports = __webpack_public_path__ + "static/bike-6c3eef21dcc3691391c2d12fe3386de2.jpg";